<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">
              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text" :placeholder="'Кадастр рақамини киритинг'" v-model="filter.cadastreDocNumber" @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="col-12 table-responsive mt-4">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th>Бино номи</th>
                      <th>Кадастр раками</th>
                      <th>Мулк эгаси</th>
                      <th>Манзил</th>
                      <th>Умумий майдон(кв.м)</th>
                      <th>Умумий қурилиш ости майдон(кв.м)</th>
                      <th>Умумий фойдали майдон(кв.м)</th>
                      <th>Қурилган йили</th>
                      <th>Кадастр маълумоти</th>
                      <th>Киритилган сана</th>
                      <th class="text-center">
                          {{$t("realEstate.field.action")}}
                      </th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                      <tr v-for="result in results.data" :key="result.id">
                          <td>{{result.id}}</td>
                          <td>
                              <div style="font-weight: bold">{{result.name}}</div>
                              <div class="badge badge-success">
                                  <span v-if="result.category==='Notorious'">Нотурар</span>
                                  <span v-if="result.category==='Residential'">Турар</span>
                              </div>
                          </td>
                          <td>{{result.cadastreDocNumber}}</td>
                          <td>
                              <template v-if="result.owner">
                                  <div class="text-info">{{result.owner.fullName}}</div>
                                  <div class="text-warning">{{result.owner.firmName}}</div>
                              </template>
                          </td>
                          <td>
                              <div class="text-secondary" v-if="result.province">{{result.province.name}}</div>
                              <div class="text-info" v-if="result.region">{{result.region.name}}</div>
                          </td>
                          <td>{{result.evlGroundArea}}</td>
                          <td>{{result.evlBuildingWidthArea}}</td>
                          <td>{{result.evlUsefulField}}</td>
                          <td>{{result.builtYear}}</td>
                          <td class="td-actions text-center">
                              <button class="all-btn view-btn table-action" v-tooltip="'Кадастр хакикий маълумотини куриш'" @click="onShowCadastreData(result)">
                                  <i class="fa fa-eye"></i>
                              </button>
                              <button class="all-btn edit-btn table-action" v-tooltip="'Кадастр маълумотини куриш'" @click="onShowCadastreViewData(result)">
                                  <i class="fa fa-edit"></i>
                              </button>
                          </td>
                          <td>{{new Date(result.createdDate) | dateFormat('DD/MM/YYYY HH:mm')}}</td>
                          <td class="text-center">
                              <div class="form-group">
                                <div class="form-check pl-0" v-tooltip="'Кадастр маълумотини янгилашга рухсат бериш'">
                                  <label class="form-check-label" style="padding-left:22px !important">
                                    <input class="form-check-input" type="checkbox" v-model="result.updatable" @change="onUpdateData(result)" :disabled="result.updatable">
                                    <span class="form-check-sign"></span>
                                  </label>
                                </div>
                              </div>
                              {{result.updatable}}
                          </td>
                      </tr>
                  </tbody>
                  <tfoot v-if="!loading && results && results.data && results.data.length > 0">
                      <tr>
                          <td colspan="10" class="text-right">Жами:</td>
                          <td></td>
                          <td class="text-center">{{results.data.length}} та</td>
                      </tr>
                  </tfoot>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <base-modal :data="data" title="'КАДАСТР МАЪЛУМОТЛАРИ'"></base-modal>
        <cadastre-historical-view-modal></cadastre-historical-view-modal>

    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import BaseModal from '@/components/BaseModal'
    import CadastreHistoricalViewModal from './CadastreHistoricalViewModal'

    export default {
        components: {
            'b-pagination': bPagination,
            BaseModal,
            CadastreHistoricalViewModal
        },
        data() {
            return {
                loading: false,
                processing: false,
                filter: initFilterModel(),
                show: false,
                results: null,
                data: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                if (this.filter.cadastreDocNumber && this.filter.cadastreDocNumber.length > 0)
                    this.filter.page.page = 1;
                this.$http.post('cadastre-historical/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        console.log(res.data)
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onUpdateData(data) {
                if (data.updatable) {
                    this.processing = true;
                    this.$http.post('cadastre-historical/updatable', data)
                        .then(res => {
                            this.processing = false;
                            if (res.data && res.data.status === 'SUCCESS') {
                                this.$swal({
                                    title: this.$t('messages.common.success'),
                                    text: this.$t('messages.cadastreHistorical.updateSuccess'),
                                    type: 'success'
                                });
                            }
                        }, err => {
                            console.log(err);
                            this.processing = false;
                        });
                }
            },
            onShowCadastreData(data) {
                this.data = data.cadastreApiData;
                this.$eventBus.$emit("showBaseModal")
            },
            onShowCadastreViewData(data) {
                this.data = data.cadastreApiData;
                this.$eventBus.$emit("showCadastreHistoricalViewModal", data)
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>